{/* New Design */}
const FONT_FAMILY = 'Manrope';

/*1rem = 16px (Default)*/
export const typography = {
  fontFamily: FONT_FAMILY,
  
  /*Display Large*/
  title: {
    fontSize: '4rem',//64px
    fontWeight: 400,
    lineHeight: 1.0625,//68 / 64
    letterSpacing: '-2px',
  },
  /*Display Medium*/
  header: {
    fontSize: '2.75rem',//52px
    fontWeight: 400,
    lineHeight: 1.154, //60 / 52
    letterSpacing: '-1px',
  },
  /*Headlines: xL > L > M > S > xS > xxS */
  h1: {
    fontSize: '2.5rem',//40px
    fontWeight: 400,
    lineHeight: 1.2, //48 / 40
    letterSpacing: '-2px',
  },

  h2: {
    fontSize: '2.25rem',//36px
    fontWeight: 400,
    lineHeight: 1.222, //44 / 36
    letterSpacing: '-2px',
  },

  h3: {
    fontSize: '2rem',//32px
    fontWeight: 400,
    lineHeight: 1.25,//40 / 32
    letterSpacing: '-1px',
  },

  h4: {
    fontSize: '1.75rem',//28px
    fontWeight: 400,
    lineHeight: 1.357, //38 / 28
    letterSpacing: '-1px',
  },

  h5: {
    fontSize: '1.375rem',//22px
    fontWeight: 400,
    lineHeight: 1.364, //30 / 22
  },

  h6: {
    fontSize: '1.25rem',//20px
    fontWeight: 400,
    lineHeight: 1.4, //28 / 20
  },
  
  /*Text xL*/
  subtitle1: {
    fontSize: '1.125rem',//18px
    fontWeight: 400,
    lineHeight: 1.556, //28 / 18
    letterSpacing: '-0.1',
  },
  /*Text L*/
  subtitle2: {
    fontSize: '1rem',//16px
    fontWeight: 400,
    lineHeight: 1.5, //24 / 16
    letterSpacing: '-0.1',
  },
  
  /*Text S*/
  body1: {
    fontSize: '0.875rem',//14px
    fontWeight: 500,
    lineHeight: 1.429, //20 / 14
    letterSpacing: '-0.1',
  },

  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.429,
    letterSpacing: '-0.1px',
  },
  /*Text xS*/
  caption: {
    fontSize: '0.75rem',//12px
    fontWeight: 400,
    lineHeight: 1.5, //18 / 12
    letterSpacing: '-0.1px',
  },
};

{/* Old (Current Design) */}
/*export default {*/
/*  h1: {*/
/*    fontWeight: 500,*/
/*    fontSize: 35,*/
/*    letterSpacing: '-0.24px'*/
/*  },*/
/*  h2: {*/
/*    fontWeight: 500,*/
/*    fontSize: 28,*/
/*    letterSpacing: '-0.24px'*/
/*  },*/
/*  h3: {*/
/*    fontWeight: 500,*/
/*    fontSize: 24,*/
/*    letterSpacing: '-0.06px',*/
/*    textTransform: 'capitalize',*/
/*  },*/
/*  h4: {*/
/*    fontWeight: 500,*/
/*    fontSize: 20,*/
/*    letterSpacing: '-0.06px'*/
/*  },*/
/*  h5: {*/
/*    fontWeight: 500,*/
/*    fontSize: 15,*/
/*    letterSpacing: '-0.05px'*/
/*  },*/
/*  h6: {*/
/*    fontSize: 12,*/
/*    fontWeight: 500,*/
/*    /*lineHeight: 1.6,*/
/*    letterSpacing: '-0.05px'*/
/*  },*/
/*  overline: {*/
/*    fontWeight: 500*/
/*  },*/
/*  logo: {*/
/*    fontWeight: 500,*/
/*    fontSize: 24,*/
/*    letterSpacing: '-0.06px',*/
/*    color: '#ffffff',*/
/*    border: '1px solid'*/
/*  },*/
/*  body1: {*/
/*    fontSize: 12,*/
/*    /*color: '#8f8c8c',*/
/*  },*/
/*  body2: {*/
/*    fontSize: 12,*/
/*    /*textTransform: 'upperCase',*/
/*  },*/
/*  subtitle1: {*/
/*    fontSize: '.90rem',*/
/*  },*/
/*  subtitle2: {*/
/*    color: '#8f8c8c',*/
/*  },*/
/*  error: {*/
/*    fontSize: 12,*/
/*    textTransform: 'upperCase',*/
/*    fontWeight: 600*/
/*  },*/
/*};  */